msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/SessionDirectory.tsx
msgid " (conversation default)"
msgstr " (conversation default)"

#: src/components/SessionDirectory.tsx
msgid " (current)"
msgstr " (current)"

#: src/components/UserPanel.tsx
msgid "+ create agent"
msgstr "+ create agent"

#: src/components/NormalizedConversation.tsx
msgid "A message could not be sent."
msgstr "A message could not be sent."

#: src/i18n/errorMessages.ts
msgid "A Zone with this name already exists."
msgstr "A Zone with this name already exists."

#: src/components/UserPanel.tsx
msgid "Account"
msgstr "Account"

#: src/components/UserPresenceDot.tsx
msgid "Active just now"
msgstr "Active just now"

#: src/components/NormalizedConversation.tsx
#: src/components/UserPanel.tsx
msgid "Agent"
msgstr "Agent"

#: src/i18n/errorMessages.ts
msgid "Agents cannot mention everyone."
msgstr "Agents cannot mention everyone."

#: src/components/UserName.tsx
msgid "APP"
msgstr "APP"

#: src/components/common/PageHeader.tsx
msgid "Back"
msgstr "Back"

#: src/i18n/documentTitle.ts
msgid "Borgee Admin"
msgstr "Borgee Admin"

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry Project recovery."
msgstr "Browser storage could not be cleared; reload may retry Project recovery."

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry recovery."
msgstr "Browser storage could not be cleared; reload may retry recovery."

#: src/stores/useServerStore.ts
msgid "Browser storage could not be cleared; reload may retry this request."
msgstr "Browser storage could not be cleared; reload may retry this request."

#: src/components/ClearConfirmModal.tsx
#: src/components/ConfirmDeleteModal.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/hooks/useWebSocket.ts
msgid "Channel #{name} was deleted."
msgstr "Channel #{name} was deleted."

#: src/i18n/errorMessages.ts
msgid "Check the Zone details and try again."
msgstr "Check the Zone details and try again."

#: src/i18n/errorMessages.ts
msgid "Choose a valid location for this conversation."
msgstr "Choose a valid location for this conversation."

#: src/i18n/errorMessages.ts
msgid "Choose a valid notification preference."
msgstr "Choose a valid notification preference."

#: src/components/ClearConfirmModal.tsx
msgid "Clear"
msgstr "Clear"

#: src/components/ClearConfirmModal.tsx
msgid "Clear local chat history? This only clears the local display and does not affect server data."
msgstr "Clear local chat history? This only clears the local display and does not affect server data."

#: src/components/common/PageHeader.tsx
msgid "Close"
msgstr "Close"

#: src/components/ShellLayout.tsx
msgid "Collapse sidebar"
msgstr "Collapse sidebar"

#: src/components/ConnectionStatus.tsx
msgid "Connecting…"
msgstr "Connecting…"

#: src/components/ConnectionStatus.tsx
msgid "Connection lost. Reconnecting…"
msgstr "Connection lost. Reconnecting…"

#: src/components/NormalizedSessionComposer.tsx
msgid "Conversation unavailable. Your draft is preserved."
msgstr "Conversation unavailable. Your draft is preserved."

#: src/components/NormalizedConversation.tsx
msgid "Conversation view"
msgstr "Conversation view"

#: src/stores/useServerStore.ts
msgid "Could not create the Project."
msgstr "Could not create the Project."

#: src/App.tsx
msgid "Could not load this Project."
msgstr "Could not load this Project."

#: src/hooks/useRemoteNodes.ts
msgid "Could not load your computers."
msgstr "Could not load your computers."

#: src/stores/useServerStore.ts
msgid "Could not refresh Project membership."
msgstr "Could not refresh Project membership."

#: src/stores/useServerStore.ts
msgid "Could not save Project creation recovery. Check browser storage and try again."
msgstr "Could not save Project creation recovery. Check browser storage and try again."

#: src/hooks/useUserLayout.ts
msgid "Could not save sidebar order. Please try again."
msgstr "Could not save sidebar order. Please try again."

#: src/components/UserPanel.tsx
msgid "Could not sign out. Try again."
msgstr "Could not sign out. Try again."

#: src/lib/visibility.ts
msgid "Creator only"
msgstr "Creator only"

#: src/components/PersonalSettingsModal.tsx
msgid "Dark Mode"
msgstr "Dark Mode"

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete"
msgstr "Delete"

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete <0>#{channelName}</0>? This cannot be undone."
msgstr "Delete <0>#{channelName}</0>? This cannot be undone."

#: src/components/ConfirmDeleteModal.tsx
msgid "Delete channel"
msgstr "Delete channel"

#: src/components/ConfirmDeleteModal.tsx
msgid "Deleting…"
msgstr "Deleting…"

#: src/components/ConnectionStatus.tsx
msgid "Disconnected"
msgstr "Disconnected"

#: src/App.tsx
msgid "Dismiss"
msgstr "Dismiss"

#: src/lib/notificationPermissionLabels.ts
msgid "Enable notifications"
msgstr "Enable notifications"

#: src/i18n/errorMessages.ts
msgid "Enter a Guild name."
msgstr "Enter a Guild name."

#: src/lib/use_failure_repair.ts
msgid "Enter a new API key"
msgstr "Enter a new API key"

#: src/i18n/errorMessages.ts
msgid "Enter a search query."
msgstr "Enter a search query."

#: src/i18n/errorMessages.ts
msgid "Everyone was mentioned recently. Please try again later."
msgstr "Everyone was mentioned recently. Please try again later."

#: src/components/ShellLayout.tsx
msgid "Expand sidebar"
msgstr "Expand sidebar"

#: src/components/SessionDirectory.tsx
msgid "Filter"
msgstr "Filter"

#: src/components/SessionDirectory.tsx
msgid "Filter loaded sessions"
msgstr "Filter loaded sessions"

#: src/components/LanguageSelect.tsx
msgid "Follow system"
msgstr "Follow system"

#: src/components/PersonalSettingsModal.tsx
msgid "General"
msgstr "General"

#: src/components/UserPanel.tsx
msgid "Human"
msgstr "Human"

#: src/lib/notificationPermissionLabels.ts
msgid "Install the Borgee desktop app"
msgstr "Install the Borgee desktop app"

#: src/components/LanguageSelect.tsx
msgid "Language"
msgstr "Language"

#: src/components/UserPresenceDot.tsx
msgid "Last active {lastSeen}"
msgstr "Last active {lastSeen}"

#: src/components/PersonalSettingsModal.tsx
msgid "Light Mode"
msgstr "Light Mode"

#: src/App.tsx
msgid "Loading Agent…"
msgstr "Loading Agent…"

#: src/App.tsx
msgid "Loading Project..."
msgstr "Loading Project..."

#: src/components/SessionDirectory.tsx
msgid "Loading sessions…"
msgstr "Loading sessions…"

#: src/App.tsx
msgid "Loading..."
msgstr "Loading..."

#: src/App.tsx
msgid "Loading…"
msgstr "Loading…"

#: src/components/UserPanel.tsx
msgid "Logout"
msgstr "Logout"

#: src/lib/visibility.ts
msgid "Members only"
msgstr "Members only"

#: src/lib/capability-bundles.ts
msgid "Mention capabilities"
msgstr "Mention capabilities"

#: src/i18n/errorMessages.ts
msgid "Mention recipients must be selected through the message editor."
msgstr "Mention recipients must be selected through the message editor."

#: src/components/NormalizedConversation.tsx
msgid "Messages"
msgstr "Messages"

#: src/components/ShellLayout.tsx
msgid "Navigation"
msgstr "Navigation"

#: src/components/NormalizedSessionComposer.tsx
msgid "No active turn was stopped. The turn may have already finished."
msgstr "No active turn was stopped. The turn may have already finished."

#: src/components/SessionDirectory.tsx
msgid "No registered sessions. Send a message to start a session."
msgstr "No registered sessions. Send a message to start a session."

#: src/components/SessionDirectory.tsx
msgid "No sessions match this filter."
msgstr "No sessions match this filter."

#: src/lib/notificationPermissionLabels.ts
msgid "Notifications enabled"
msgstr "Notifications enabled"

#: src/lib/notificationPermissionLabels.ts
msgid "Notifications were blocked. Enable them in your browser settings."
msgstr "Notifications were blocked. Enable them in your browser settings."

#: src/components/UserPresenceDot.tsx
msgid "Offline"
msgstr "Offline"

#: src/lib/syncState.ts
msgid "Offline mode"
msgstr "Offline mode"

#: src/components/UserPresenceDot.tsx
msgid "Online"
msgstr "Online"

#: src/components/SessionDirectory.tsx
msgid "Only part of the session list is available."
msgstr "Only part of the session list is available."

#: src/i18n/errorMessages.ts
msgid "Only the sender can edit this message."
msgstr "Only the sender can edit this message."

#: src/components/NormalizedConversation.tsx
msgid "Open Messages to retry"
msgstr "Open Messages to retry"

#: src/lib/router.tsx
msgid "Open overview"
msgstr "Open overview"

#: src/components/SessionDirectory.tsx
msgid "Opened sessions"
msgstr "Opened sessions"

#: src/lib/use_failure_repair.ts
msgid "Opening logs…"
msgstr "Opening logs…"

#: src/lib/router.tsx
msgid "Page not found"
msgstr "Page not found"

#: src/i18n/errorMessages.ts
msgid "Please try again."
msgstr "Please try again."

#: src/App.tsx
msgid "Preparing your workspace. Refresh shortly…"
msgstr "Preparing your workspace. Refresh shortly…"

#: src/components/UserPanel.tsx
msgid "Profile and settings"
msgstr "Profile and settings"

#: src/App.tsx
msgid "Project not found"
msgstr "Project not found"

#: src/lib/capability-bundles.ts
msgid "Reading capabilities"
msgstr "Reading capabilities"

#: src/lib/use_failure_repair.ts
msgid "Reconnecting…"
msgstr "Reconnecting…"

#: src/components/SessionDirectory.tsx
msgid "Refresh sessions"
msgstr "Refresh sessions"

#: src/components/ShellLayout.tsx
msgid "Resize thread"
msgstr "Resize thread"

#: src/App.tsx
msgid "Retry"
msgstr "Retry"

#: src/components/NormalizedConversation.tsx
#: src/components/SessionDirectory.tsx
msgid "Retry sessions"
msgstr "Retry sessions"

#: src/App.tsx
msgid "Select a computer from the sidebar"
msgstr "Select a computer from the sidebar"

#: src/App.tsx
msgid "Select a conversation to start messaging"
msgstr "Select a conversation to start messaging"

#: src/components/SessionDirectory.tsx
msgid "Select a session"
msgstr "Select a session"

#: src/components/NormalizedConversation.tsx
msgid "Select a session to continue."
msgstr "Select a session to continue."

#: src/App.tsx
msgid "Select an agent from the sidebar"
msgstr "Select an agent from the sidebar"

#: src/components/SessionDirectory.tsx
msgid "Selected session"
msgstr "Selected session"

#: src/components/NormalizedSessionComposer.tsx
msgid "Send a message to this conversation"
msgstr "Send a message to this conversation"

#: src/components/NormalizedConversation.tsx
msgid "Send or remove attached images in Messages before switching to Session."
msgstr "Send or remove attached images in Messages before switching to Session."

#. placeholder {0}: agentName ?? t`this agent`
#: src/components/NormalizedConversation.tsx
msgid "Send your first message to {0} below. Session activity and any available controls will appear after the agent starts the session. Your conversation messages remain visible while it starts."
msgstr "Send your first message to {0} below. Session activity and any available controls will appear after the agent starts the session. Your conversation messages remain visible while it starts."

#: src/components/NormalizedSessionComposer.tsx
msgid "Sending a new message to this session is not available here."
msgstr "Sending a new message to this session is not available here."

#: src/components/NormalizedConversation.tsx
msgid "Sending message…"
msgstr "Sending message…"

#: src/components/NormalizedConversation.tsx
#: src/components/SessionDirectory.tsx
msgid "Session"
msgstr "Session"

#: src/components/NormalizedSessionComposer.tsx
msgid "Session controls are unavailable. Your draft is preserved."
msgstr "Session controls are unavailable. Your draft is preserved."

#: src/components/SessionDirectory.tsx
msgid "Session ID"
msgstr "Session ID"

#: src/components/NormalizedConversation.tsx
msgid "Session not started"
msgstr "Session not started"

#: src/components/NormalizedConversation.tsx
msgid "Session setup"
msgstr "Session setup"

#: src/components/SessionDirectory.tsx
msgid "Sessions could not be loaded."
msgstr "Sessions could not be loaded."

#: src/components/SessionDirectory.tsx
msgid "Sessions in this direct message"
msgstr "Sessions in this direct message"

#: src/components/PersonalSettingsModal.tsx
#: src/components/UserPanel.tsx
msgid "Settings"
msgstr "Settings"

#: src/lib/syncState.ts
msgid "Synced"
msgstr "Synced"

#: src/lib/syncState.ts
msgid "Syncing…"
msgstr "Syncing…"

#: src/components/NormalizedSessionComposer.tsx
msgid "The agent rejected this control. Your draft is preserved."
msgstr "The agent rejected this control. Your draft is preserved."

#: src/hooks/useWebSocket.ts
msgid "The channel was deleted."
msgstr "The channel was deleted."

#: src/components/NormalizedSessionComposer.tsx
msgid "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."
msgstr "The control result is unconfirmed. Check the session state before trying again. Your draft is preserved."

#: src/i18n/errorMessages.ts
msgid "The conversation location changed. Refresh and try again."
msgstr "The conversation location changed. Refresh and try again."

#: src/i18n/errorMessages.ts
msgid "The Guild icon is too long."
msgstr "The Guild icon is too long."

#: src/components/NormalizedSessionComposer.tsx
msgid "The native turn has already finished. Your draft is preserved."
msgstr "The native turn has already finished. Your draft is preserved."

#: src/i18n/errorMessages.ts
msgid "The operation failed (error code: {code})."
msgstr "The operation failed (error code: {code})."

#: src/App.tsx
msgid "The Project was created, but its data could not be loaded. Reload to retry."
msgstr "The Project was created, but its data could not be loaded. Reload to retry."

#: src/stores/useServerStore.ts
msgid "The Project was created, but recovery could not be completed. Retry to load the Project."
msgstr "The Project was created, but recovery could not be completed. Retry to load the Project."

#: src/i18n/errorMessages.ts
msgid "The requested item is no longer available."
msgstr "The requested item is no longer available."

#: src/i18n/errorMessages.ts
msgid "The search query is too long."
msgstr "The search query is too long."

#: src/i18n/errorMessages.ts
msgid "The search query is too short."
msgstr "The search query is too short."

#: src/components/PersonalSettingsModal.tsx
msgid "Theme"
msgstr "Theme"

#: src/i18n/errorMessages.ts
msgid "This action can only edit messages in direct conversations."
msgstr "This action can only edit messages in direct conversations."

#: src/components/NormalizedConversation.tsx
msgid "this agent"
msgstr "this agent"

#: src/i18n/errorMessages.ts
msgid "This channel is read-only. Only its creator can send messages."
msgstr "This channel is read-only. Only its creator can send messages."

#: src/i18n/errorMessages.ts
msgid "This conversation field cannot be changed."
msgstr "This conversation field cannot be changed."

#: src/i18n/errorMessages.ts
msgid "This notification subscription belongs to another account."
msgstr "This notification subscription belongs to another account."

#: src/i18n/errorMessages.ts
msgid "This notification subscription is invalid. Enable notifications again."
msgstr "This notification subscription is invalid. Enable notifications again."

#: src/i18n/errorMessages.ts
msgid "This request was already used with different details. Try again."
msgstr "This request was already used with different details. Try again."

#: src/components/NormalizedSessionComposer.tsx
msgid "This session does not support that control."
msgstr "This session does not support that control."

#: src/components/NormalizedConversation.tsx
msgid "This session is unavailable. Your selection is preserved."
msgstr "This session is unavailable. Your selection is preserved."

#: src/i18n/errorMessages.ts
msgid "This Zone is not empty. Archived channels also prevent deletion."
msgstr "This Zone is not empty. Archived channels also prevent deletion."

#: src/i18n/errorMessages.ts
msgid "This Zone no longer exists."
msgstr "This Zone no longer exists."

#: src/i18n/errorMessages.ts
msgid "Too many requests. Please try again later."
msgstr "Too many requests. Please try again later."

#: src/lib/visibility.ts
msgid "Visible to the organization"
msgstr "Visible to the organization"

#: src/components/NormalizedSessionComposer.tsx
msgid "Wait until the agent is idle before changing this session."
msgstr "Wait until the agent is idle before changing this session."

#: src/components/UserPanel.tsx
msgid "with <0>{agentCount}</0> {agentCount, plural, one {agent} other {agents}}"
msgstr "with <0>{agentCount}</0> {agentCount, plural, one {agent} other {agents}}"

#: src/lib/capability-bundles.ts
msgid "Workspace capabilities"
msgstr "Workspace capabilities"

#: src/i18n/errorMessages.ts
msgid "You are not a member of this conversation."
msgstr "You are not a member of this conversation."

#: src/i18n/errorMessages.ts
msgid "You do not have permission to perform this action."
msgstr "You do not have permission to perform this action."

#: src/hooks/useUnsavedChangesGuard.ts
msgid "You have unsaved changes:\n"
"{changes}\n"
"\n"
"Leave this page?"
msgstr "You have unsaved changes:\n"
"{changes}\n"
"\n"
"Leave this page?"

#: src/hooks/useUnsavedChangesGuard.ts
msgid "You have unsaved changes. Leave this page?"
msgstr "You have unsaved changes. Leave this page?"

#: src/stores/useServerStore.ts
msgid "You no longer have access to the created Project."
msgstr "You no longer have access to the created Project."

#: src/components/UserPanel.tsx
msgid "your agents"
msgstr "your agents"

#: src/components/LanguageSelect.tsx
msgid "Your language choice could not be saved in this browser. It will apply until this page is closed."
msgstr "Your language choice could not be saved in this browser. It will apply until this page is closed."

#: src/i18n/errorMessages.ts
msgid "Your session ended. Sign in again."
msgstr "Your session ended. Sign in again."
